var React = require('react');

function ChatIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#fff;stroke-width:2px;}")),React.createElement("g",{"transform":"translate(-306.05 -397.553)","key":1},React.createElement("path",{"className":"a","d":"M312.644,416.372v7.7l10.632-11.2h11.164V400.968a2.414,2.414,0,0,0-2.415-2.415H307.05v14.32h6.778"}))]);
}

ChatIcon.defaultProps = {"width":"29.389","height":"29.021","viewBox":"0 0 29.389 29.021"};

module.exports = ChatIcon;

ChatIcon.default = ChatIcon;
